/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const positionCenter = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M7 9v6h10V9H7zM5 19.8h14v-1.5H5v1.5zM5 4.3v1.5h14V4.3H5z" />
	</SVG>
);

export default positionCenter;
